import type { Dictionary } from './en'

export const es = {
  nav: { features: 'Funciones', pricing: 'Precio', faq: 'Preguntas', account: 'Mi cuenta', signIn: 'Iniciar sesión' },

  hero: {
    title: 'Alt-Tab para tu Mac',
    tagline: 'macOS cambia de app. AppSwitch hace que ⌥Tab cambie de ventana — todas tus ventanas, incluidos los tres documentos abiertos en la misma app.',
    download: 'Descargar para Mac',
    seePricing: 'Ver precio',
    note: 'Gratis · macOS 15 o posterior · Apple silicon e Intel',
    hint: 'Mantén ⌥ y pulsa Tab — suelta para cambiar',
  },

  features: {
    heading: 'Para quien tiene veinte ventanas abiertas',
    sub: 'Una pulsación de ⌥Tab las muestra todas. Sueltas y ya estás allí.',
    items: [
      { title: 'Cada ventana, no cada app', body: 'El selector de macOS cambia entre apps. AppSwitch cambia entre ventanas — incluidos los tres documentos abiertos en la misma app.' },
      { title: 'Primero el teclado', body: '⌥Tab para avanzar, ⌥⇧Tab para retroceder, flechas para moverte por la cuadrícula. Suelta ⌥ y la ventana elegida pasa al frente.' },
      { title: 'Nunca roba el foco', body: 'Tu app sigue activa hasta que eliges de verdad. AppSwitch vive en la barra de menús, sin icono en el Dock que estorbe.' },
      { title: 'Vistas previas en directo', body: 'Ve el contenido real de cada ventana en lugar de un icono genérico. Las ventanas minimizadas aparecen dentro del propio selector.' },
    ],
  },

  pricing: {
    heading: 'Cómpralo una vez. Es tuyo.',
    sub: 'El selector es gratuito y completo — no es una prueba ni una versión recortada. Pro añade las dos funciones que necesitan licencia.',
    free: 'Gratis', pro: 'Pro', ribbon: 'Pago único',
    freePrice: '0 €', once: 'una vez',
    freeSub: 'Todo lo necesario para dejar de usar ⌘Tab.',
    proSub: 'Sin suscripción. Nada se renueva, nunca.',
    freeList: [
      'Selector de ventanas completo en ⌥Tab',
      'Navegación con teclado y ratón',
      'Vista de cuadrícula y de lista',
      'App de barra de menús, sin icono en el Dock',
    ],
    proList: [
      'Todo lo de la versión gratuita',
      'Vistas previas en directo de cada ventana',
      'Ventanas minimizadas en el selector',
      'Dos Mac por licencia',
    ],
    download: 'Descargar', buy: 'Consigue AppSwitch Pro', buyBusy: 'Abriendo el pago…',
    freeFoot: 'Sin cuenta. Sin tarjeta. Sin caducidad.',
  },

  faq: {
    heading: 'Preguntas',
    items: [
      { q: '¿Por qué AppSwitch necesita acceso a Accesibilidad?', a: 'Es la única forma en que macOS permite a una app capturar ⌥Tab antes que las demás, enumerar tus ventanas y traer una al frente. Sin él la app no puede funcionar. Lo concedes tú en Ajustes del Sistema y puedes retirarlo cuando quieras.' },
      { q: '¿Es una suscripción?', a: 'No. AppSwitch Pro es un pago único. Nada se renueva, nada se vuelve a cobrar, y las actualizaciones de la versión mayor actual están incluidas.' },
      { q: '¿En cuántos Mac puedo usarlo?', a: 'Dos por licencia. Puedes liberar una plaza cuando quieras desde tu cuenta o desde la app, así que cambiar de máquina nunca es una incidencia.' },
      { q: '¿Envía los títulos de mis ventanas a algún sitio?', a: 'No. Ningún contenido de ventana, ningún título y ninguna pulsación de tecla sale de tu Mac. La única petición de red es la comprobación de licencia, y solo si compraste Pro. La versión gratuita nunca usa la red.' },
      { q: '¿Qué versiones de macOS admite?', a: 'macOS 15 o posterior, en Apple silicon e Intel.' },
    ],
  },

  listMode: {
    heading: 'Dos formas de ver tus ventanas',
    sub: 'Se cambia desde la barra de menús, o con la tecla , mientras el selector está abierto.',
    grid: { title: 'Cuadrícula, con vistas previas', body: 'Miniaturas del contenido real. Ideal cuando reconoces una ventana por lo que muestra.' },
    list: { title: 'Lista, con títulos completos', body: 'Una columna densa donde el título entero de cada ventana cabe en una línea. Ideal para veinte terminales, o archivos cuyos nombres solo difieren al final.' },
  },

  footer: { terms: 'Términos de uso', privacy: 'Privacidad' },

  consent: {
    text: 'Usamos Google Analytics para saber qué páginas resultan útiles. No se mide nada sin tu consentimiento. Consulta nuestra',
    privacyLink: 'política de privacidad',
    accept: 'Aceptar', decline: 'Rechazar',
  },
} satisfies Dictionary
